import React from 'react'
import injectSheet from 'react-jss'
import compose from 'recompose/compose'
import pure from 'recompose/pure'
import withProps from 'recompose/withProps'
import StopsListTitle from './StopsListTitle'
import { MAIN_SCENE_ACTIVATION_ZONE_INDEX } from 'aria-viewer/keyboard/constants/tabIndices'

const styleSheet = {
    gradient: {
        zIndex: 5,
        width: 200,
        height: '100%',
        position: 'absolute',
        left: 0,
        top: 0,
        backgroundImage: 'linear-gradient(to left, rgba(8, 19, 30, 0), rgba(8, 19, 30, 0.4))',
    },

    container: {
        fontWeight: 400,
        userSelect: 'none',
        color: 'white',
        position: 'absolute',
        left: 30,
        top: '50%',
        transform: 'translateY(-50%)',
        zIndex: 5,
        height: ({ totalHeight }) => totalHeight,
        marginTop: ({ isMapEnabled }) => (isMapEnabled ? -120 : 0),
        borderLeft: '2px solid white',
        cursor: 'default',
    },

    activationZone: {
        height: '90%',
        width: 150,
        position: 'absolute',
        zIndex: 5,
    },

    line: {
        height: ({ individualHeight }) => individualHeight,
        position: 'absolute',
        top: ({ index, step }) => index * step,
        left: -2,
        borderLeft: '4px solid #ffab00',
    },
}

const style = injectSheet(styleSheet)

const props = withProps(({ stopListLength, stopsList, height }) => {
    const individualHeight = 36
    const totalHeight = Math.min(stopListLength * individualHeight, height * 0.4)
    const step = (totalHeight - individualHeight) / (stopListLength - 1)

    return {
        individualHeight,
        totalHeight,
        step,
    }
})

const StopsList = ({ classes, index, step, individualHeight, onMouseEnter, onKeyPress, list }) => (
    <div>
        <div className={classes.gradient} />

        <div className={classes.container}>
            <div
                className={classes.activationZone}
                id="open_scene_selector"
                tabIndex={MAIN_SCENE_ACTIVATION_ZONE_INDEX}
                onMouseEnter={onMouseEnter}
                onFocus={onMouseEnter}
                onClick={onMouseEnter}
                onKeyPress={onKeyPress}
            />

            <div className={classes.line} />

            {list.map(({ title, ii }) => (
                <StopsListTitle
                    key={ii}
                    options={{
                        ii,
                        step,
                        index,
                        individualHeight,
                        title,
                    }}
                />
            ))}
        </div>
    </div>
)

StopsList.defaultProps = {
    list: [],
    stopListLength: 0,
}

export default compose(props, style, pure)(StopsList)
